import React from "react";
import { Link } from "react-router-dom";
import { setHeaderCollapse } from "../data/redux/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CollapseHeader = () => {
  const dispatch = useDispatch();
  const headerCollapse = useSelector((state: any) => state.commonSlice.headerCollapse);

  const toggleHeaderCollapse = () => {
    dispatch(setHeaderCollapse(!headerCollapse));
  };

  const handleRefresh = () => {
    // Reload the current page
    window.location.reload();
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
      >
        <Link to="#" onClick={handleRefresh}>
          <i className="ti ti-refresh-dot" style={{
            cursor: 'pointer'
          }} />
        </Link>
      </OverlayTrigger>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="collapse-tooltip">
          {headerCollapse ? 'Expand' : 'Collapse'}
        </Tooltip>}
      >
        <Link 
          to="#" 
          id="collapse-header" 
          onClick={toggleHeaderCollapse}
          className={headerCollapse ? 'collapsed' : ''}
        >
          <i className="ti ti-chevrons-down" style={{ 
            transform: headerCollapse ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease-in-out'
          }} />
        </Link>
      </OverlayTrigger>
    </>
  );
};

export default CollapseHeader;
